import React from "react";
import { Navigate } from "react-router-dom";
import Layout from "../Layout";

const PrivateRoute = ({ isAuthenticated, children }) => {
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/" />;
};

export default PrivateRoute;
